export const styleOverrides = {
  root: ({ theme }) => ({
    padding: theme.spacing(2),
  }),
};
